import { useEffect, useState } from 'react'

export default function NetworkStatus() {
  const [offline, setOffline] = useState(!navigator.onLine)
  const [update, setUpdate] = useState(false)
  useEffect(() => {
    const online = () => setOffline(false)
    const offline = () => setOffline(true)
    const updated = () => setUpdate(true)
    window.addEventListener('online', online)
    window.addEventListener('offline', offline)
    window.addEventListener('b2b-update-ready', updated)
    if ('serviceWorker' in navigator) void navigator.serviceWorker.getRegistration().then(r => { if (r?.waiting) setUpdate(true) })
    return () => { window.removeEventListener('online', online); window.removeEventListener('offline', offline); window.removeEventListener('b2b-update-ready', updated) }
  }, [])
  async function refresh() {
    const registration = await navigator.serviceWorker.getRegistration()
    if (registration?.waiting) {
      navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true })
      registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    } else window.location.reload()
  }
  if (!offline && !update) return null
  return <div role="status" className="relative z-[60] flex flex-wrap items-center justify-center gap-3 bg-amber-100 px-4 py-2 text-center text-sm text-amber-950">
    {offline ? 'Você está sem conexão. Reconecte para consultar dados e enviar alterações.' : <>
      <span>Há uma nova versão. Termine e salve o que está fazendo antes de atualizar.</span>
      <button onClick={() => void refresh()} className="min-h-11 rounded-lg border border-amber-300 px-4 font-semibold">Atualizar agora</button>
    </>}
  </div>
}
